export default __webpack_public_path__ + "assets/f20eddbd357eaffce502a4e4f360b267.png";